import { Form } from '@sravni/cosago-react-library/lib/components';
import { Typography } from '@sravni/react-design-system';
import type { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

export const FormBlockLabel: FC<Props> = (props) => {
  const { children, className } = props;
  return (
    <Form.Row colWidths={[12]}>
      <Typography.Text
        strong
        size={16}
        className={className}
      >
        {children}
      </Typography.Text>
    </Form.Row>
  );
};
